import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setTextToSearch } from "shared/components/Cards/Card/cardTextSlice";
import { loadMorePrompts } from "./GuidePromptsSearcher/guidePromptsSlice";
import { CopyToClipboardButton } from "shared/components/Buttons/CopyToClipboardButton/CopyToClipboardButton";
import { ShareButton } from "shared/components/Buttons/ShareButton/ShareButton";
import { Prompt, promptsList } from "shared/functions/promptsList";
import "./GuidePrompts.css";

interface PromptProps {
  alpha2Code?: string;
  alpha3Code?: string;
  category: string;
  name: string;
  promp: string;
  text: string;
}

interface GuidePromptsProps {
  onClose: () => void;
}

export const GuidePrompts = ({ onClose }: GuidePromptsProps) => {
  const [selectedPrompt, setSelectedPrompt] = useState<Prompt | null>(null);
  const dispatch = useDispatch();

  let templates = useSelector((state: any) => state.guidePrompsSearcher.value);
  let displayCount = useSelector((state: any) => state.guidePrompsSearcher.displayCount);
  
  const onCardClick = (content: string) => {
    dispatch(setTextToSearch(content));
    onClose();
  };

  const handleLoadMore = () => {
    dispatch(loadMorePrompts());
  };

  const displayedPrompts = templates.slice(0, displayCount);
  const hasMorePrompts = templates.length > displayCount;

  return (
    <>
      <div className="prompt-list">
        {displayedPrompts.map((item: any, index: number) => (
          <div key={index} className="prompt-list__card" onClick={() => onCardClick(item.content)}>
            <div className="prompt-list__card--content">
              <span className="prompt-list__card--title">{item.content}</span>
              <span className="badge">{item.category}</span>
            </div>
            <div className="prompt-list__card--actions">
              <CopyToClipboardButton textToCopy={item.content} onClose={onClose} />
              <ShareButton promptToShare={item.content} onClose={onClose} />
            </div>
          </div>
        ))}
        
        {hasMorePrompts && (
          <button 
            className="prompt-list__more-button"
            onClick={handleLoadMore}
            aria-label="Load more prompts"
          >
            More...
          </button>
        )}
      </div>
    </>
  );
};
